import styled, { css } from 'styled-components';
import { Box, BoxProps } from '@bechtel/gds';

export interface AddCaddySectionProps {
  isRodRoomAttendant: boolean;
}

type BoxAddCaddySectionProps = AddCaddySectionProps;

export const CaddyContainerStyled = styled(Box).attrs({
  flexDirection: { sm: 'column' },
  flexGrow: { sm: 1 },
})`
  ${({ theme }) => css`
    background-color: ${theme.colors.white};
    border-radius: ${theme.radii[200]};
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2);
  `};
`;

export const CaddyCardsContainerStyled = styled(Box).attrs({
  flexDirection: { sm: 'column' },
  pl: { sm: '600' },
  pt: { sm: '500' },
  pb: { sm: '550' },
})`
  ${({ theme }) => css`
    background-color: ${theme.colors.grey[100]};
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2);
  `};
`;

export const FooterStyled = styled(Box).attrs({ p: { sm: '500' }, justifyContent: { sm: 'space-between' } })`
  background-color: ${({ theme }) => theme.colors.blue[800]};
`;

export const AddCaddySectionStyled = styled(Box).attrs({
  flexDirection: { sm: 'column' },
  flexGrow: { sm: 1 },
})<BoxAddCaddySectionProps>`
  overflow-y: auto;
  ${({ isRodRoomAttendant }) => (!isRodRoomAttendant ? `height: calc(100vh - 260px);` : `height: calc(100vh - 195px);`)}
`;
